module.exports = __webpack_public_path__ + "img/upcommingEvents5.0ec65978.jpg";